import React from 'react';
import { connect } from 'react-redux';
import { updatePhaseTask, clearValidationErrors } from 'actionCreators';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import PropTypes from 'prop-types';
import DepartedModal from '../departedModal';
import DepartedChecklistModal from '../departedChecklistModal';
import isIfiPhase from '../ifiUtils';
import PhaseTask from './phase_task';

export class Departed extends PhaseTask {
  onClick = () => {
    const { phase, task } = this.props;
    if (!phase || !task) return;

    if (task.status === 'complete') {
      this.toggleStatus();
    } else if (this.shouldShowModal()) {
      this.setState({ modalActive: true });
    } else {
      this.completeTask();
    }
  }

  isIhqWorkroom = () => {
    const { phase } = this.props;
    return phase && phase.workroom && (phase.workroom.ihq === true || phase.workroom.ihq === 'true');
  }

  isInstallationOrWorkorder = () => {
    const { phase } = this.props;
    return !!phase && (phase.type === 'Installation' || phase.type === 'Workorder');
  }

  shouldShowModal = () => {
    const { phase } = this.props;
    if (!phase || !phase.type) return false;

    // For Installations/Workorders: show the departed reminder checklist, but only for IFI phases
    if (this.isInstallationOrWorkorder()) {
      return isIfiPhase(phase);
    }

    // For Assessments: show modal only if IHQ is enabled (to show disposition)
    return phase.type === 'Assessment' && this.isIhqWorkroom();
  }

  confirmDeparture = () => {
    this.completeTask();
    this.setState({ modalActive: false });
  }

  renderChildren = () => {
    const { phase } = this.props;
    if (!phase || !phase.type || !this.shouldShowModal()) return null;

    if (this.isInstallationOrWorkorder()) {
      return (
        <DepartedChecklistModal
          active={this.state.modalActive}
          onConfirm={this.confirmDeparture}
          onClose={this.handleClose}
        />
      );
    }

    return (
      <DepartedModal
        phase={this.props.phase}
        task={this.props.task}
        active={this.state.modalActive}
        completeTask={this.completeTask}
        onClose={this.handleClose}
      />
    );
  }
}

Departed.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
};

export const departed = connect(() => ({}), { updatePhaseTask, clearValidationErrors })(Departed);
export const departed_from_appointment = departed;
export const workorder_departed = departed;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/departed.jsx